// extracted by mini-css-extract-plugin
export default {"bigWrapper":"App_bigWrapper__SNfIM","blueShape":"App_blueShape__xI9wn"};